import { Expose, Type } from 'class-transformer';
import { BaseModel } from '../../../common-sdk';

class ProjectCompanySettings {
  companyId?: string;
  requestForDPR?: boolean;
  adminApprovalForNewServicesRequired?: boolean;
  branchCanGenerateReports?: boolean;
  customerAdminCanAskForCollection?: boolean;
  requestForCollection?: boolean;
  declarationChangeAcceptanceISAdministrator?: boolean;
  declarationChangeAcceptanceCustomerAdministrator?: boolean;
  declarationChangeAcceptanceCustomerBranch?: boolean;
  declarationChangeAcceptanceRegionalAdministrator?: boolean;
}

class ProjectPix {
  pixExchangeRateId?: string;
  eurExchangeRateId?: string;
  valueSubstractedFromPix?: number; // in cents
  dateFrom?: Date;
  dateTo?: Date;
}

export class ProjectClientBindingModel extends BaseModel {
  @Expose()
  companyId?: string;

  @Expose()
  branchId?: string;

  @Expose()
  companyName?: string;

  @Expose()
  branchName?: string;

  @Expose()
  @Type(() => String)
  projectId?: string;

  @Expose()
  projectNumber?: string;

  @Expose()
  projectName?: string;

  @Expose()
  type?: 'CLIENT' | 'SUBCONTRACTOR';

  @Expose()
  sellerPerson?: string;

  @Expose()
  projectLeadPerson?: string;

  @Expose()
  invoicePerson?: string;

  @Expose()
  projectType?: string;

  @Expose()
  creationDate?: Date;

  @Expose()
  settings?: ProjectCompanySettings;
}
